import { Alert } from "antd";

import { PLATFORM_ENVS, RUNNING_ENV_IS } from "constants/commons";

export function BannerOfTheEnvIs(): JSX.Element {
  const showBanner = RUNNING_ENV_IS?.envKey !== PLATFORM_ENVS.production.envKey;

  return !showBanner ? null : (
    <Alert
      banner
      type="info"
      message={`Entorno de ${RUNNING_ENV_IS.name.es}`}
      style={{
        fontSize: "1.125em",
        position: "sticky",
        top: "0",
        zIndex: 100,
        fontWeight: 500,
      }}
    />
  );
}
